import React from 'react';

const EditableResidentList = ({ residents, removeResident, updateResident, schedulerMode }) => {
  const handleFrequencyChange = (index, newFrequency) => {
    const updatedResident = { ...residents[index], max1inX: parseFloat(newFrequency) };
    updateResident(index, updatedResident);
  };

  return (
    <div className="editable-resident-list">
      {residents.map((resident, index) => (
        <div key={index} className="resident-info">
          {resident.name}:
          <input
            className="call-freq-in"
            type="number"
            value={resident.max1inX}
            onChange={(e) => handleFrequencyChange(index, e.target.value)}
            min="1"
            step="1"
          />
          {schedulerMode === 'resident' && (
            <span className="onespace">days</span>
          )}
          {schedulerMode === 'attending' && (
            <span className="onespace">weeks</span>
          )}
          <button className="remove-button" onClick={() => removeResident(index)}>Remove</button>
        </div>
      ))}
    </div>
  );
};

export default EditableResidentList;